import React, { useCallback, useEffect } from 'react';
import { UserIdName } from 'redux/models/userIdName';
import { Tooltip } from '@material-ui/core';
import UserIconImage from 'assets/images/user-icon.svg';

export const setupReceivingUsers = function (users: UserIdName[]) {
	let postUsers: any = [];
	let moreUsersCount = 0;
	let moreUsersNames = '';
	for (let i = 0; i < users.length; i++) {
		const user = users[i];
		if (i > 2) {
			moreUsersCount++;
			i + 1 === users.length ? (moreUsersNames += `${user.name}`) : (moreUsersNames += `${user.name}, `);
		}
		if (!moreUsersCount) {
			postUsers.push(
				<span key={i} className="post-item__comment-user">
					{user.name},{' '}
				</span>
			);
		}
	}
	if (moreUsersCount > 0) {
		postUsers.push(
			<Tooltip key={3} title={moreUsersNames} placement="top" interactive>
				<span className="post-item__comment-more-count">+{moreUsersCount} more, </span>
			</Tooltip>
		);
	}
	return postUsers;
};

export const setupStatUsers = function (users: UserIdName[]) {
	let postUsers: any = [];
	let moreUsersCount = 0;
	let moreUsersNames = '';
	for (let i = 0; i < users.length; i++) {
		const user = users[i];
		if (i > 2) {
			moreUsersCount++;
			i + 1 === users.length ? (moreUsersNames += `${user.name}`) : (moreUsersNames += `${user.name}, `);
		}
		if (!moreUsersCount) {
			if (i < 2 && i !== users.length - 1) {
				postUsers.push(
					<span key={i} className="post-item__comment-user">
						{user.name},{' '}
					</span>
				);
			} else {
				if (i !== users.length - 1) {
					postUsers.push(
						<span key={i} className="post-item__comment-user">
							{user.name},{' '}
						</span>
					);
				} else {
					postUsers.push(
						<span key={i} className="post-item__comment-user">
							{user.name}
						</span>
					);
				}
			}
		}
	}
	if (moreUsersCount > 0) {
		postUsers.push(
			<Tooltip key={3} title={moreUsersNames} placement="top" interactive>
				<span className="post-item__comment-more-count">+{moreUsersCount} more </span>
			</Tooltip>
		);
	}
	return postUsers;
};

export const setupLikes = function (likes: UserIdName[]) {
	let likesNames: string = '';
	for (let i = 0; i < likes.length; i++) {
		const like = likes[i];
		if (i + 1 === likes.length) {
			likesNames += `${like.name}`;
		} else {
			likesNames += `${like.name}, `;
		}
	}
	return likesNames;
};

export const addDefaultProfileImgSrc = (e: any) => {
	e.target.src = UserIconImage;
	e.target.onerror = null;
};


export const useDebouncedEffect = (effect: () => void, delay: number, deps: any[]) => {
	const callback = useCallback(effect, deps);

	useEffect(() => {
		const handler = setTimeout(() => {
			callback();
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [callback, delay]);
};
